<template>
  <div class="pa-5" style="height: 100%">
    <!-- <div v-if="creating">
      <div class="mb-2">
        <v-progress-circular indeterminate color="primary" class="mr-4"></v-progress-circular>
        <span>
          Đang tạo điểm học sinh...
        </span>
      </div>
      <v-progress-linear v-model="progress" color="success" height="25" rounded>
        <strong>{{ Math.ceil(progress) }}%</strong>
      </v-progress-linear>
    </div> -->
    <div class="d-flex align-center">
      <v-text-field v-model="excelFileName" outlined prepend-inner-icon="mdi-file" disabled hide-details />
      <v-btn color="primary" @click="cancelChooseFile" text>Chọn tệp khác</v-btn>
    </div>

    <div class="my-4">
      <span class="error--text">*</span>
      <span class="font-weight-medium">
        Vui lòng kiểm tra lại thông tin học sinh và điểm và ấn [Thêm điểm] để tạo mới điểm số
      </span>
    </div>
    <v-card outlined>
      <StepPreviewTable />
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import StepPreviewTable from './StepPreviewTable.vue'
export default {
  components: { StepPreviewTable },
  computed: {
    ...mapState('ClassMarkInput', ['excelFileName'])
  },
  methods: {
    ...mapActions({
      resetExcelImportState: 'ClassMarkInput/resetExcelImportState'
    }),
    cancelChooseFile() {
      this.resetExcelImportState()
      this.$emit('on-cancel-file')
    }
  }
}
</script>
